import { Form, Radio } from 'antd';
import type { ReactNode } from 'react';

import type { SCRAPER_NAME } from '../../types';

export const ScraperOptionField = (props: {
  scraperOptions: { label: ReactNode; value: SCRAPER_NAME }[];
  disabled?: boolean;
}) => {
  const { scraperOptions, disabled } = props;

  return (
    <Form.Item
      style={{ display: scraperOptions.length > 1 ? 'block' : 'none' }}
      label="Scraping by"
      required
      name="scraper_name"
      rules={[{ required: true, message: 'Scraping by is required' }]}
    >
      <Radio.Group disabled={disabled}>
        {scraperOptions.map((scraperOption) => (
          <Radio key={scraperOption.value} value={scraperOption.value}>
            {scraperOption.label}
          </Radio>
        ))}
      </Radio.Group>
    </Form.Item>
  );
};
